import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/pages/login/Login.vue'
import Layout from '@/layout/Layout.vue'
import Home from '@/pages/home/home.vue'
import Dashboard from '@/pages/dashboard/Dashboard.vue'
import DeviceList from '@/pages/device/DeviceList.vue'
import VehicleList from '@/pages/vehicle/VehicleList.vue'
import WeighAudit from '@/pages/weigh/WeighAudit.vue'
import CollectSummary from '@/pages/report/CollectSummary.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      children: [
        { path: 'home', component: Home, meta: { title: '首页' } },
        { path: 'device/list', component: DeviceList, meta: { title: '设备管理' } },
        { path: 'dashboard', component: Dashboard, meta: { title: '车辆轨迹' } },
        { path: 'vehicle/list', component: VehicleList, meta: { title: '车辆管理' } },
        { path: 'weigh/audit', component: WeighAudit, meta: { title: '过磅审核' } },
        { path: 'report/collect-summary', component: CollectSummary, meta: { title: '小区清运统计' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')
  if (to.path !== '/login' && !token) return next('/login')
  next()
})

export default router